import { reactive, computed } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

export default function useCalendar() {
  const selectedDate = reactive({
    from: undefined,
    to: undefined,
  });

  function clickDateHandler($event: any) {
    selectedDate.from = useFormat.date($event).computerShortDate();
    // selectedDate.to = $event.endStr;
  }

  const allowedToBooking = computed(() => {
    const result = selectedDate.from;
    //  && selectedDate.to;
    return result;
  });

  return {
    selectedDate,
    allowedToBooking,
    clickDateHandler,
  };
}
